export const AppointmentStatus: {
    REQUESTED: 'REQUESTED',
    SCHEDULED: 'SCHEDULED',
    COMPLETED: 'COMPLETED',
    CANCELLED: 'CANCELLED',
    CALLED_OFF: 'CALLED_OFF',
    DECLINED: 'DECLINED',
    NO_SHOW: 'NO_SHOW',
} = {
    REQUESTED: 'REQUESTED',
    SCHEDULED: 'SCHEDULED',
    COMPLETED: 'COMPLETED',
    CANCELLED: 'CANCELLED',
    CALLED_OFF: 'CALLED_OFF',
    DECLINED: 'DECLINED',
    NO_SHOW: 'NO_SHOW',
};

export type AppointmentStatus = (typeof AppointmentStatus)[keyof typeof AppointmentStatus];

export const getAppointmentStatusLabel = (status: AppointmentStatus): string => {
    switch (status) {
        case AppointmentStatus.REQUESTED:
            return 'REQUESTED - Termin ANGEFRAGT (vom Kunden)'; // Or "Anfrage erhalten", "Wartet auf Bestätigung", etc.
        case AppointmentStatus.DECLINED:
            return 'DECLINED - Termin ABGELEHNT (von Kalia)';
        case AppointmentStatus.SCHEDULED:
            return 'SCHEDULED - Termin GEPLANT'; // Or "Bestätigt", "Termin bestätigt"
        case AppointmentStatus.COMPLETED:
            return 'COMPLETED - Termin ABGESCHLOSSEN';
        case AppointmentStatus.CANCELLED:
            return 'CANCELLED - Termin ABGESAGT (vom Kunden)';
        case AppointmentStatus.NO_SHOW:
            return 'NO_SHOW - Kunde NICHT ERSCHIENEN'; // Or "Kein Erscheinen"
        case AppointmentStatus.CALLED_OFF:
            return 'CALLED_OFF - Termin ABGESAGT (von Kalia)';
        default:
            return 'Unbekannter Status'; // Add a default case for safety
    }
};